
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorThreewayJoint as ObiConnectorThreewayJointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-threeway-joint.js';
 
 
 

 
 export const ObiConnectorThreewayJoint = createComponent({
   react: React,
   tagName: 'obi-connector-threeway-joint',
   elementClass: ObiConnectorThreewayJointElement,
   events: {
     
   }
  });
 
 